import React from 'react';

const CalculationNotesModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="modal-content" style={{ background: 'white', borderRadius: 8, padding: 32, maxWidth: 600, width: '90%', boxShadow: '0 2px 16px rgba(0,0,0,0.18)' }}>
        <h2>Calculation Logic</h2>
        <div style={{ maxHeight: 340, overflowY: 'auto', paddingRight: 8 }}>
          <ul style={{ marginTop: 16, marginBottom: 0 }}>
            <li><strong>Markup %:</strong> ((Bill Rate - Pay Rate) / Bill Rate) × 100</li>
            <li><strong>Gross Profit:</strong> Bill Rate - Pay Rate</li>
            <li><strong>Hours Per Month:</strong> 40 hours/week × 4 weeks/month = 160 hours</li>
            <li><strong>GP/Hour:</strong> Gross Profit / 160</li>
            <li><strong>Bill Rate (with discount):</strong> Bill Rate × (1 - Discount/100)</li>
            <li><strong>Potential Monthly Commission:</strong>
              <ul style={{ marginTop: 4, marginBottom: 4 }}>
                <li><strong>C2C:</strong> Bill Rate × 160 hours</li>
                <li><strong>W2 Hourly:</strong> Gross Profit × 160 hours</li>
                <li><strong>Full-Time:</strong> Bill Rate (as provided)</li>
              </ul>
            </li>
            <li><strong>GP % (W2/Full-Time):</strong> (Bill Rate - Loaded Cost) / Bill Rate × 100</li>
            <li><strong>Loaded Cost (W2/Full-Time):</strong> Pay Rate × 1.18 (default, can be customized)</li>
            <li><strong>Smart Calculation:</strong> Enter any two of (Bill Rate, Pay Rate, GP%) and the third will be calculated automatically.</li>
            <li><strong>Discount %:</strong> Applied to the final bill rate after all other calculations.</li>
            <li><strong>Allowed Markup %:</strong> Pay Rate = Bill Rate ÷ (1 + Markup%), ignoring loaded cost/burden</li>
          </ul>
        </div>
        <button onClick={onClose} style={{ marginTop: 24, padding: '8px 24px', background: '#0078d4', color: 'white', border: 'none', borderRadius: 4, fontWeight: 600, cursor: 'pointer' }}>Close</button>
      </div>
    </div>
  );
};

export default CalculationNotesModal;
